import { WHITE_LABEL_DOMAIN } from '@/features/shared/constants/whitelabel'
import { objectStorageUrl } from '@/features/shared/utils/objectStorageUrl'

export type SeoSchemaImage = {
  url: string
  width: number | undefined
  height: number | undefined
}

export const SEO_CONSTANTS = {
  rootDomain: `https://www.${WHITE_LABEL_DOMAIN}`,
  ogSiteName: 'Shipt Grocery Delivery',
  ogLocale: 'en_US',
  ogType: 'website',
  twitterCard: 'summary_large_image',
  twitterHandle: '@Shipt',
  googleVerification: '-uT3EyH_XO74edf6qtNyUKNittSYs5J1yW38p3PacGY',
  defaultSeoImage: {
    url: objectStorageUrl('get-started-hero.png'),
    width: 872,
    height: 1072,
  },
} as const

export const getCanonicalUrl = (pathname: string) => `${SEO_CONSTANTS.rootDomain}${pathname}`
